import { getSessionStorageValue, setSessionStorageValue, STORAGE_KEYS } from './SessionStorage';

const keyFor = (mobile, operation) => `${operation}:${mobile}`;

export function getOtpApiAttempts(mobile, operation, now = Date.now()) {
  const record = getSessionStorageValue(STORAGE_KEYS.OTP_API_ATTEMPTS, {})?.[keyFor(mobile, operation)];
  if (!record || (record.lockedUntil && record.lockedUntil <= now)) return null;
  return record;
}

export function recordOtpApiAttempts(mobile, operation, response, now = Date.now()) {
  const body = response?.response?.data ?? response;
  const data = body?.data;
  if (!data || typeof data !== 'object') return;
  if (!['locked', 'seconds_remaining', 'attempts_left', 'max_attempts'].some((key) => key in data)) return;
  const seconds = Number(data.seconds_remaining);
  const locked = data.locked === true || response?.response?.status === 429;
  const record = {
    lockedUntil: locked && Number.isFinite(seconds) && seconds > 0 ? now + seconds * 1000 : 0,
    attemptsLeft: Number.isInteger(data.attempts_left) ? data.attempts_left : null,
    maxAttempts: Number.isInteger(data.max_attempts) ? data.max_attempts : null,
    message: typeof body.message === 'string' ? body.message : '',
  };
  const stored = getSessionStorageValue(STORAGE_KEYS.OTP_API_ATTEMPTS, {});
  setSessionStorageValue(STORAGE_KEYS.OTP_API_ATTEMPTS, { ...stored, [keyFor(mobile, operation)]: record });
}

export function otpResponseError(body, fallback) {
  const error = new Error(body?.message || fallback);
  error.response = { data: body };
  return error;
}
